const reports = {
  title: 'Reports',

  filters: {
    all_time: 'All time',
    all_campaigns: 'All campaigns',
    today: 'Today',
    last_7_days: 'Last 7 days',
    last_30_days: 'Last 30 days',
    this_month: 'This month',
    last_month: 'Last month',
    custom_range: 'Custom range',
    from: 'From',
    to: 'To',
    apply: 'Apply',
    clear: 'Clear'
  },

  types: {
    title: 'Report Types',
    create_custom: 'Create Custom Report',
    performance: { title: 'Performance Report', subtitle: 'Overall performance and KPI' },
    campaign: { title: 'Campaign Report', subtitle: 'Detailed campaign performance' },
    audience: { title: 'Audience Report', subtitle: 'Viewer demographics and insights' },
    location: { title: 'Location Report', subtitle: 'Performance by location' },
    device: { title: 'Device Report', subtitle: 'Performance by devices' },
    daily_summary: { title: 'Daily Summary', subtitle: 'Day by day performance summary' },
    customer: { title: 'Customer Report', subtitle: 'Build your own report' }
  },

  recent: {
    title: 'Recent Reports',
    columns: {
      name: 'Report Name',
      type: 'Type',
      period: 'Period',
      generated_on: 'Generated On',
      format: 'Format',
      status: 'Status'
    },
    empty_title: 'No reports yet',
    empty_hint: "Reports will appear here once there's enough data to generate them.",
    download: 'Download',
    delete: 'Delete'
  },

  status: {
    completed: 'Completed',
    processing: 'Processing',
    failed: 'Failed'
  }
}

export default reports
